/*
 * Created on Thu Oct 12 2023 10:21:45 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import * as types from '../action/types';

const initialState = {
    isAuthenticated: false,
    loading: false,
    alert: false,
    hasFailedLogin: false,
    inactiveAccountLogin: false,
    courseSchedules: localStorage.getItem('courseSchedules') || []
}

const courseSchedules = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_ALL_COURSE_SCHEDULES:
            localStorage.setItem('isAuthenticated', true);
            localStorage.setItem('courseSchedules', JSON.stringify(payload.listOfOutputs) || []);
            return {
                ...state,
                ...payload,
                courseSchedules: JSON.parse(localStorage.getItem('courseSchedules')) || []
            };
        case types.CREATE_COURSE_SCHEDULE:
            localStorage.setItem('isAuthenticated', true);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false,
                alert: false,
            };

        case types.UPDATE_COURSE_SCHEDULE:
            localStorage.setItem('isAuthenticated', true);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false,
                alert: false,
            };
        case types.ASSIGN_STUDENT_COURSE:
            localStorage.setItem('isAuthenticated', true);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false,
                alert: false,
            };
        case types.ASSIGN_STUDENT_LIST_COURSE:
                localStorage.setItem('isAuthenticated', true);
                return {
                    ...state,
                    ...payload,
                    isAuthenticated: true,
                    loading: false,
                    alert: false,
                };
        case types.REMOVE_COURSE_SCHEDULE_STUDENT:
                localStorage.setItem('isAuthenticated', true);
                return {
                    ...state,
                    ...payload,
                    isAuthenticated: true,
                    loading: false,
                    alert: false,
                };
    
        case types.GET_COURSE_SCHEDULE:
            localStorage.setItem('isAuthenticated', true);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false,
                alert: false,
            };
        case types.RETRIEVE_COURSE_SCHEDULE:
            localStorage.setItem('isAuthenticated', true);
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false,
                courseSchedules: JSON.parse(localStorage.getItem('courseSchedules')) || []
            };
        default:
            return state;
    }
}

export default courseSchedules;
